import { Action } from '@ngrx/store';

export const ActionTypes = {
    USER_UPDATE: '[User Container] Update',
    PREFERRED_BRANCH_UPDATE: '[User Container] Update preferred branch',
    LOGGED_IN_UPDATE: '[Logged in Container] Update',
    RIGHTS_UPDATE: '[Rights container] Update'
};

export class UpdateUser implements Action {
    type = ActionTypes.USER_UPDATE;
    payload: {
        name: string;
        email: string;
        language: string;
        userId: string;
        oci: boolean;
    };

    public constructor(user: any) {
        this.payload = user;
    }
}

export class UpdatePreferredBranch implements  Action {
    type = ActionTypes.PREFERRED_BRANCH_UPDATE;
    payload: string;

    public constructor(branch: string) {
        this.payload = branch;
    }
}

export class UpdateLoggedIn implements Action {
    type = ActionTypes.LOGGED_IN_UPDATE;
    payload: boolean;

    public constructor(loggedIn: boolean) {
        this.payload = loggedIn;
    }
}

export class UpdateRights implements Action {
    type = ActionTypes.RIGHTS_UPDATE;
    payload: string[];

    public constructor(rights: string[]) {
        this.payload = rights;
    }
}
